// Components
import { LegalPageContent } from '../../components/LegalPageContent/LegalPageContent';

export const TermsOfServicePage = () => {
  return <LegalPageContent slug="terms-of-service" fallbackTitle="Terms of Service" />;
};
